module.exports = __webpack_public_path__ + "static/media/enabledVerticalTicketIcon.78425d90.svg";